import React, { Component } from 'react';
import SelectAziende from './SelectAziende';
import CreaMenu from './CreaMenu';
import CreaPacchetto from './CreaPacchetto';
import { BASE_URL } from './config';
import CreaTradizioni from './CreaTradizioni';
import SelectTipologie from './SelectTipologia';

class CreaEvento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAziendaId: '',
      selectedAziendaType: '',
      selectedCategoria: '', 
      formData: {
        titolo: '',
        descrizione: '',
        dataInizio: '',
        dataFine: '',
        campiMenu: [],
        categorie: [], // Stato per le categorie disponibili
        prezzo: 0,
        immagineCopertina: null
      }
    };
  }

  componentDidMount() {
    const { idAzienda } = this.props;
    this.fetchInitialAziende(idAzienda);
  }

  fetchInitialAziende = (idAzienda) => {
    
    const headers = new Headers({
      'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
    });

    let url = idAzienda
      ? `${BASE_URL}/azienda/${idAzienda}`
      : `${BASE_URL}/v1/user/aziende`;

    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        
        if (Array.isArray(data) && data.length > 0) {
          const firstAzienda = data[0];
          this.setState({
            selectedAziendaId: firstAzienda.idAzienda,
            selectedAziendaType: firstAzienda.tipologie?.code || ''
          });
          this.fetchCategorie();
        } else {
          this.fetchCategorie();
        }
      })
      .catch(() => {});
  };

  fetchCategorie = () => {
    const headers = new Headers({
      'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
    });

    
    fetch(`${BASE_URL}/eventi/tipologie`, { headers })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          this.setState(prevState => ({
            formData: { ...prevState.formData, categorie: data }
          }));
        }
      })
      .catch(() => {});
  };

  handleSelectedAzienda = (azienda) => {
    this.setState({
      selectedAziendaId: azienda.id,
      selectedAziendaType: azienda.tipologia
    });
    this.fetchCategorie();
  };

  handleSelectChange = (categoria, tipologia ) => {
    
    this.setState({ selectedCategoria: categoria.code, selectedTipologia: tipologia });
  };

  handleSubmit = (formData) => {
    const { selectedTipologia } = this.state;
    const { idAzienda } = this.props;
    const headers = new Headers({
      'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
    });

    const finalFormData = {
      ...formData,
      tipologiaEvento: selectedTipologia,
      idAzienda: idAzienda
    };

    fetch(`${BASE_URL}/eventi`, {
      method: 'POST',
      headers,
      body: JSON.stringify(finalFormData)
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          formData: {
            titolo: '',
            descrizione: '',
            dataInizio: '',
            dataFine: '',
            campiMenu: [],
            categorie: [],
            prezzo: 0,
            immagineCopertina: null
          },
          selectedCategoria: ''
        });
      })
      .catch(() => {});
  };

  render() {
    const { selectedCategoria, selectedAziendaId, formData } = this.state;

    let componenteForm = null;
  
    if (selectedCategoria === 'food') {
      componenteForm = <CreaMenu onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    } else if (selectedCategoria === 'tradition') {
      componenteForm = <CreaTradizioni onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    } else if (selectedCategoria === 'transport') {
      componenteForm = <CreaPacchetto onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    }
    else if (selectedCategoria === 'solemare') {
      componenteForm = <CreaPacchetto onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    }
  
  

    return (
      <div className='main-content'>
        <center>
          <SelectAziende onSelectedData={this.handleSelectedAzienda} />
        </center>
        <SelectTipologie data={formData.categorie} onChange={this.handleSelectChange} />
        {componenteForm}
      </div>
    );
  }
}

export default CreaEvento;
